import React, { ReactNode } from "react";
import { CenteredSimpleLayout } from "./CenteredSimpleLayout";
import { DefaultLayout } from "./DefaultLayout";
import styles from "./LoadingLayout.module.css";

type Props = {
  children: ReactNode;
};

// TODO: Rename component. It is used for errors and no data errors aswell
export const LoadingLayout: React.FC<React.PropsWithChildren<Props>> = ({
  children,
}) => {
  return (
    <DefaultLayout>
      <CenteredSimpleLayout>
        <div className={styles.container}>{children}</div>
      </CenteredSimpleLayout>
    </DefaultLayout>
  );
};
